// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getFunctions } from 'firebase/functions'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyCTNVlNBHlVEyWTE64WoV3FOKZlCMvhigk',
  authDomain: 'peacegame-somalia.firebaseapp.com',
  projectId: 'peacegame-somalia',
  storageBucket: 'peacegame-somalia.appspot.com',
  messagingSenderId: '1045410788601',
  appId: '1:1045410788601:web:fdd44dcc60fcfc3c52de28'
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
const auth = getAuth(app)
const db = getFirestore(app)
const functions = getFunctions(app)

export { auth, db, functions }
